import Cookies from 'js-cookie';

const authenticationCheck = () => {
  const accessToken = localStorage.getItem('hcatkn');
  const refreshToken = localStorage.getItem('hcrtkn');
  const orthancToken = Cookies.get('orthanc_token');
  const orthancRefreshToken = Cookies.get('refresh_token')

  if (!accessToken || !refreshToken || !orthancToken || !orthancRefreshToken) {
    return false;
  }



  return true;
};

export default authenticationCheck;
